'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const PermissionsContext = /*#__PURE__*/React.createContext(null);
const usePermissions = () => {
  const context = React.useContext(PermissionsContext);
  if (!context) {
    throw new Error('No context provided for PermissionsContext provider');
  }
  return context;
};
const PermissionsProvider = _ref => {
  let {
    children,
    value
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement(PermissionsContext.Provider, {
    value: value
  }, children);
};

exports.PermissionsContext = PermissionsContext;
exports.PermissionsProvider = PermissionsProvider;
exports.usePermissions = usePermissions;
